import { JSX, ReactNode, useState } from 'react'

import { For, Tabs, TabsValueChangeDetails } from '@chakra-ui/react'


import { scroll_styles } from './main.tsx'




export type TOption = {
	value: string
	label: string
	icon : JSX.Element

	content: ReactNode

}

export type TOptions = TOption[]


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Trigger
(props: Omit<TOption, 'content'>): JSX.Element
{
	return (
		<Tabs.Trigger value={props.value}>
			{props.icon}

			<span>{props.label}</span>

		</Tabs.Trigger>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function List
(props: { options: TOptions }): JSX.Element
{
	return (
		<Tabs.List pl="2" colorPalette="orange" flexShrink={0}>
			<For each={props.options}>
				{(v, i) => <Trigger key={`${i}.${v.value}`} {...v} /> }

			</For>

		</Tabs.List>
	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Content
(props: TOption): JSX.Element
{
	return (
		<Tabs.Content pt="0" value={props.value} {...scroll_styles}>
			{props.content}

		</Tabs.Content>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root
(
	props: {
		default: string
		options: TOptions

		children: ReactNode
	},

)
:	JSX.Element
{
	let [defalut_] = props.options

	let [option, update_option] = useState(props.default || defalut_?.value || '')


	let on_change = (e: TabsValueChangeDetails): void =>
	{
		update_option(e.value)

	}

	return (
		<Tabs.Root
			composite
			lazyMount
			h="full"
			bg="white"
			shadow="sm"
			rounded="md"
			display="flex"
			flexDirection="column"
			defaultValue={option}
			onValueChange={on_change}
			children={props.children}
		/>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export default function Default
(
	props: {
		default: string
		options: TOptions

	},

)
:	JSX.Element
{
	return (
		<Root default={props.default} options={props.options}>
			<List options={props.options} />

			<For each={props.options}>
				{(v, i) => <Content key={`${i}.${v.value}`} {...v} /> }

			</For>


		</Root>

	)

}
